<div class="veh-selector">
    <label class="zone-label" [ngStyle]="{'visibility': value ? 'visible' : 'hidden'}">
        {{ 'vehicles-selector.vehicle' | translate | capitalizeFirst }}
    </label>

    <p-dropdown [options]="availableVehicles" [(ngModel)]="value" optionLabel="displayValue" optionValue="value" [disabled]="disabled"
        [showClear]="true" [filter]="true" filterBy="displayValue" styleClass="w-full"
        [placeholder]="'vehicles-selector.vehicle' | translate | capitalizeFirst" (onChange)="onSelectChange($event.value)"
        (onClear)="onSelectChange(null)" appendTo="body" filterMatchMode="startsWith">
    </p-dropdown>
</div>